import { inject, Injectable } from '@angular/core';
import { Appointment, CreateAppointmentParams } from '../../models/appointment.model';
import { AppointmentService } from '../appointment.service';
import { AvailabilitySlot, SchedulingProvider } from './scheduling-provider';

/**
 * The only SchedulingProvider this phase ships: local-only, no real calendar.
 * `findAvailability` always returns no slots (booking is a plain date/time
 * picker, not a calendar UI); `book`/`reschedule` just write the local row
 * with `calendar_sync_status: 'none'`, which AppointmentService already
 * defaults to — nothing extra to set here.
 */
@Injectable({
  providedIn: 'root',
})
export class NoopSchedulingProvider implements SchedulingProvider {
  private appointmentService = inject(AppointmentService);

  async findAvailability(_assigneeId: string, _range: { start: number; end: number }): Promise<AvailabilitySlot[]> {
    return [];
  }

  async book(params: CreateAppointmentParams): Promise<Appointment> {
    return this.appointmentService.create(params);
  }

  async reschedule(appointmentId: string, start: number, end: number): Promise<Appointment> {
    return this.appointmentService.update({ id: appointmentId, scheduled_start: start, scheduled_end: end });
  }

  async cancel(appointmentId: string): Promise<Appointment> {
    return this.appointmentService.update({ id: appointmentId, status: 'cancelled' });
  }
}
